@if (isRmbRmc) {
<div>
  <span>{{ staticText | globalTranslate }}</span>
</div>
} @if (isRmbRmc && this.selectedIndividual) {
<div><br /></div>
} @if (getValue('extras.topLevelAnswer') === 'YES') {
<div form-top>
  <p class="person-label">{{ selectedIndividual | fullname }}</p>
</div>
}
<nh-form
  [topLevelName]="'bu'"
  [individuals]="checkForDropdown ? finalListAll : individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  class="label-section"
  topLevelQuestion="{{ 'BURRIAL_TOPLEVEL_QUESTION' | globalTranslate }}"
  topLevelHintText="BURRIAL_TOPLEVEL_QUESTION_HINT"
  individualQuestion="{{ 'BURRIAL_INDIV_QUESTION' | globalTranslate }}"
  [hintText]="hintText"
  (validate)="onValidate($event)"
  (individualAnswerChanged)="onIndividualChange($event)"
>
  <section [formGroup]="getControl('data')">
    <h1 class="section-header">
      {{ "BURRIAL_STATIC_TEXT1" | globalTranslate }}
    </h1>
    <hr />

    <nh-field
      id="bu_assetType"
      label="{{ 'BURRIAL_STATIC_TEXT3' | globalTranslate }} {{
        selectedIndividual | fullname
      }}{{ 'VEHICLE_STATIC_TEXT3' | globalTranslate }} <div class=hint>{{
        'IF' | globalTranslate
      }} {{ selectedIndividual | fullname }} {{
        'BURRIAL_STATIC_TEXT4' | globalTranslate
      }}</div>"
      class="label-section"
    >
      <select
        nhTranslate
        name="assetType"
        aria-required="true"
        [attr.aria-label]="
          ('BURRIAL_STATIC_TEXT3' | globalTranslate) +
          ' ' +
          (selectedIndividual | fullname) +
          ' ' +
          ('VEHICLE_STATIC_TEXT3' | globalTranslate)
        "
        [items]="tableCodeValue('BURIALRESOURCETYPECD', 'data.assetType')"
        formControlName="assetType"
      ></select>
    </nh-field>

    <div class="pt-1 hover-red">
      <a
        class="btn btn-link hover-red"
        style="padding-left: 0"
        role="link"
        (click)="showBurialPopup()"
        tabindex="0"
        (keydown.enter)="showBurialPopup()"
        (keydown.space)="showBurialPopup(); $event.preventDefault()"
      >
        <span class="pe-2">{{ "BURRIAL_STATIC_TEXT2" | globalTranslate }}</span>
        <span><i class="fa fa-external-link" aria-hidden="true"></i></span>
      </a>
    </div>
    <br />

    <nh-field
      id="bu_redesignatedFor"
      label="{{ 'BURRIAL_STATIC_TEXT5' | globalTranslate }} {{
        getValue('data.assetType').value | globalTranslate
      }}{{ 'BURRIAL_STATIC_TEXT6' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="redesignatedFor"
        aria-required="true"
        [items]="
          tableCodeValue('BURIALRESDESIGNATEDFOR', 'data.redesignatedFor')
        "
        formControlName="redesignatedFor"
        [attr.aria-label]="
          ('BURRIAL_STATIC_TEXT5' | globalTranslate) +
          ' ' +
          (getValue('data.assetType').value | globalTranslate) +
          ' ' +
          ('BURRIAL_STATIC_TEXT6' | globalTranslate)
        "
      ></select>
    </nh-field>

    <nh-field
      id="bu_assetAmount"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'BURRIAL_STATIC_TEXT7' | globalTranslate }}"
      class="label-section"
    >
      <nh-input-group prepend="$">
        <input
          nh
          type="decimal"
          maxlength="7"
          name="assetAmount"
          formControlName="assetAmount"
          class="form-control"
          [attr.aria-label]="'BURRIAL_STATIC_TEXT7' | globalTranslate"
        />
      </nh-input-group>
    </nh-field>

    <nh-field
      id="bu_owedAmount"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'VEHICLE_STATIC_TEXT9' | globalTranslate }} {{
        selectedIndividual | fullname
      }} {{ 'BURRIAL_STATIC_TEXT8' | globalTranslate }}"
      class="label-section"
    >
      <nh-input-group prepend="$">
        <input
          nh
          type="decimal"
          maxlength="7"
          name="owedAmount"
          formControlName="owedAmount"
          class="form-control"
          [attr.aria-label]="
            ('VEHICLE_STATIC_TEXT9' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname) +
            ' ' +
            ('BURRIAL_STATIC_TEXT8' | globalTranslate)
          "
        />
      </nh-input-group>
    </nh-field>

    <br />

    <div [formGroup]="getControl('data.bankSearch')">
      @if (isEnabled('data.bankSearch.bankName')) {
      <div>
        <h2 class="section-header">
          {{ "BURRIAL_STATIC_TEXT9" | globalTranslate }}
        </h2>
        <hr />
      </div>
      }

      <nh-search
        [applicationNumber]="applicationNumber"
        keyword="bank"
        resource="banks"
        [searchOnOpen]="true"
        [columns]="resultsColumns"
        [searchGroup]="getControl('extras.helpers.search')"
        [showSearchButton]="false"
        [showSearch]="true"
        (row)="selectItem($event)"
        (reset)="deleteItem()"
        [sectionId]="'ASBUR'"
        (search)="searchHandler()"
        selectColumn="true"
      >
        <ng-container
          search-form
          [formGroup]="getControl('extras.helpers.search')"
        >
          <div class="row">
            <div class="col-12">
              <nh-field
                id="bu_bankName"
                [isRow]="true"
                [mandatory]="true"
                [attr.aria-required]="true"
                label="{{ 'BURRIAL_STATIC_TEXT10' | globalTranslate }}"
                class="label-section"
              >
                <input
                  type="text"
                  name="bankName"
                  formControlName="bankName"
                  [attr.aria-label]="'BURRIAL_STATIC_TEXT10' | globalTranslate"
                  class="form-control"
                  [maxlength]="bankNameLength"
                  [required]="isEnabled('extras.helpers.search.bankName')"
                />
              </nh-field>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-md-4">
              <nh-field
                id="bu_state"
                [isRow]="true"
                [mandatory]="true"
                [attr.aria-required]="true"
                label="{{ 'STATE' | globalTranslate }}"
                class="label-section"
              >
                <select
                  nh
                  name="state"
                  [attr.aria-label]="'STATE' | globalTranslate"
                  aria-required="true"
                  [items]="tables.STATE"
                  bindValue="code"
                  formControlName="state"
                ></select>
              </nh-field>
            </div>

            <div class="col-12 col-md-4">
              <nh-field
                id="bu_zipCode"
                [isRow]="true"
                [mandatory]="false"
                [attr.aria-required]="false"
                label="{{ 'ZIP_CODE' | globalTranslate }}"
                class="label-section"
              >
                <input
                  type="text"
                  name="zipCode"
                  [attr.aria-label]="'ZIP_CODE' | globalTranslate"
                  mask="00000-0000"
                  [validation]="false"
                  pattern=""
                  placeholder="XXXXX-XXXX"
                  formControlName="zipCode"
                  class="form-control"
                />
              </nh-field>
            </div>
          </div>
        </ng-container>
      </nh-search>

      @if (showBankAddress) {
      <nh-field
        id="bu_bankName"
        [isRow]="true"
        [mandatory]="true"
        [attr.aria-required]="true"
        label="{{ 'FINANCIAL_RESOURCES_STATIC_TEXT18' | globalTranslate }}"
        class="label-section"
      >
        <input
          type="text"
          name="bankName"
          formControlName="bankName"
          [attr.aria-label]="
            'FINANCIAL_RESOURCES_STATIC_TEXT18' | globalTranslate
          "
          class="form-control"
          [maxlength]="bankNameLength"
          [attr.disabled]="isAddressDisabled ? true : null"
          [required]="true"
        />
      </nh-field>
      } @if (showBankAddress) {
      <nh-name-address
        [addressname]="'bu_assetAddress'"
        [address]="getControl('data.assetAddress')"
        [stateDefault]="false"
        [showPopup]="false"
        [isAssistingPerson]="true"
        [tables]="tables"
        [addressFieldMandatory]="false"
        [isDisabled]="isAddressDisabled"
      ></nh-name-address>
      }
    </div>
    @if (selectedIndividual) {
    <div>
      <h2 class="section-header">
        {{ "CO-OWENERS_TITLE" | globalTranslate }}
      </h2>
      <hr />
      <nh-field
        id="bu_jointOwnership"
        label="{{ 'VEHICLE_STATIC_TEXT14' | globalTranslate }} {{
          getValue('data.assetType').value | globalTranslate
        }} {{ 'VEHICLE_STATIC_TEXT15' | globalTranslate }} {{
          selectedIndividual | fullname
        }}? <div class=hint>{{ 'BURRIAL_STATIC_TEXT11' | globalTranslate }} {{
          selectedIndividual | fullname
        }} {{ 'BURRIAL_STATIC_TEXT12' | globalTranslate }}</div>"
        class="label-section"
      >
        <select
          nhTranslate
          name="jointOwnership"
          [items]="tableCodeValue('YESNO', 'data.jointOwnership')"
          formControlName="jointOwnership"
          [attr.aria-label]="
            ('VEHICLE_STATIC_TEXT14' | globalTranslate) +
            ' ' +
            (getValue('data.assetType').value | fullname) +
            ' ' +
            ('VEHICLE_STATIC_TEXT15' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname)
          "
        ></select>
      </nh-field>
      @if (isY('data.jointOwnership')) {
      <div>
        <nh-co-owner
          [jointOwnershipInformation]="
            getControl('data.jointOwnershipInformation')
          "
          [formData]="getControl('data')"
          [addRowValid]="checkValid()"
          [coOwnerIndividuals]="coOwnerIndividuals"
          [error]="error"
          (emitValidate)="coOwnerValidate($event)"
          (errorMessage)="getErrorMessage($event)"
          [coOwnerIndivErrorMessage]="coOwnerIndivErrorMessage"
          (removeRow)="removeRow($event)"
          (addRow)="addRow()"
        ></nh-co-owner>
      </div>
      }
    </div>
    }
  </section>
</nh-form>